import React, { useEffect, useState } from "react";
import images from "../../Constant/images";
import { Container } from "./styles";
import Dropdown from "../DropDownPop";
import { useDispatch } from "react-redux";
import {
  getCourseUsersRequest,
  getCourseMessagesRequest,
} from "../../Redux/actions/home";
import { setOpenChat } from "../../Redux/actions/auth";

const ChatModal = ({ groups, }) => {
  const dispatch = useDispatch();
  const styles = {
    image: {
      height: 60,
      width: 60,
      boxShadow: "2px 5px 3px 2px #6666",
      borderRadius: 50,
    },
    modal: {
      width: "80%",
      height: "80%",
      backgroundColor: "#fff",
      zIndex: 1,
      overflow: "hidden",
    },
  };

  const [groupList, setGroupList] = useState(groups ?? []);


  const onOpenChat = (course) => {
    let data = { course_id: course?.id };
    dispatch(getCourseUsersRequest(data));
    dispatch(getCourseMessagesRequest({ course_id: course?.id }));
    dispatch(setOpenChat(true, course));
  };
  useEffect(() => {
    if (groups.length) {
      let arr = groups;
      arr.map((e) => (e["label"] = e.title));
      setGroupList(arr);
    }
  }, [groups]);

  return (
    <Container>
      <Dropdown
        items={groupList}
        icon={images.chatIcon}
        iconStyle={styles.image}
        heading={"Chats"}
        onItemClick={(e) => onOpenChat(e)}
        noItems={"No Chat Groups to show"}
        position={'top'}
        alignment={'left'}
      />
    </Container>
  );
};

export default ChatModal;
